import { AxiosError } from 'axios';

import { ApiError } from '@shared/utils/interfaces/error';

export function isApiError(error: AxiosError): error is AxiosError<ApiError> {
  return Boolean(
    'response' in error && error.response && 'data' in error.response && typeof error.response.data === 'object',
  );
}
